import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import env from 'utils/env';

const apiKey = env.get('I18N_API_KEY');
const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

const options = {
  caches: ['sessionStorage'],
};

const checkBrowserLanguage = () => {
  if (navigator.language.includes('de')) {
    return 'de';
  } else return 'en';
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    initImmediate: false,
    detection: options,
    fallbackLng: 'en',
    lng: checkBrowserLanguage(),

    ns: ['fanz-payment', 'fanz-default'],
    defaultNS: 'fanz-payment',

    supportedLngs: ['en', 'pt', 'de', 'es'],
    load: 'languageOnly',

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: loadPath,
    },
  });

export default i18n;
